module.exports = __webpack_public_path__ + "static/img/tuikuan.d21d12c0.png";